import classNames from 'classnames'
import { Avatar } from '@campgladiator/cgui-core.atoms.avatar'
import { TrainerAvatarProps } from '../../TrainerBio.d'
import styles from './TrainerAvatar.module.scss'

const TrainerAvatar = ({
  imageSrc,
  isOverlayingCover,
  ...props
}: TrainerAvatarProps) => (
  <Avatar
    src={!!imageSrc ? imageSrc : undefined}
    className={classNames(styles.avatar, {
      [styles.overlayingCover]: isOverlayingCover,
    })}
    size=""
    {...props}
  />
)

export default TrainerAvatar
